/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
import formatDateTimeToPST from "../PSTDateConvert";

const UptivityIPListSettings = () => {
    const [userName, setUserName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [apiError, setApiError] = useState(null);
    const [role, setRole] = useState('');
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);

    const [newIpRange, setNewIpRange] = useState({ cidr_value: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [ipRanges, setIpRanges] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    // Authorized Users state
    const [users, setUsers] = useState([]);
    const [totalUserItem, setTotalUserItem] = useState(0);
    const [userPage, setUserPage] = useState(1);
    const [newUser, setNewUser] = useState({ email: '' });
    const [isAddUser, setIsAddUser] = useState(false);
    const [isEditingUser, setIsEditingUser] = useState(false);
    const [editUserIndex, setEditUserIndex] = useState(null);
    const [userFormErrors, setUserFormErrors] = useState({});
    const [userButtonDisabled, setUserButtonDisabled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
    }, []);

    useEffect(() => {
        if (token) {
            getIpRangeList(page);
            getUserAccess();
        }
    }, [page, token]);

    useEffect(() => {
        if (token) {
            getUserList(userPage);
        }
    }, [userPage, token]);

    useEffect(() => {
        console.log("User role:", role);
        if (token && role != 0 && role != 1) {
            // Only SuperAdmin (role === 0 or role === 1) can access this page
            navigate('/dashboard');
        }
    }, [token, role]);

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setRole(decoded.role);
            setUserName(decoded.name);
            setExpire(decoded.exp);
        } catch (error) {
            if (error.response) {
                navigate("/");
                window.location.reload();
            }
        }
    }

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setAccess(response.data.results);
        } catch (error) {
           console.error("Error fetching user access:", error);
        }
    }

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setUserName(decoded.name);
            setExpire(decoded.exp);
            setRole(decoded.role);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const getIpRangeList = async (pageNumber) => {
        setPopupOpen(true);
        try {
            const response = await axiosJWT.get(`${baseUrl}/uptivity-ip-list?page=${pageNumber}&limit=${20}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setIpRanges(response.data.data);
            setTotalItem(response.data.totalItem);
            setApiError(null);
        } catch (err) {
            console.error("Error fetching Uptivity IP Ranges:", err);
            if (err.response?.status === 403) {
                setApiError("Access denied. This page can only be accessed by SuperAdmins from MFA-exempt IP addresses.");
            } else {
                setApiError(err.response?.data?.msg || "Failed to load Uptivity IP Ranges.");
            }
        } finally {
            setPopupOpen(false);
        }
    }

    const handleAddIpRange = () => {
        setNewIpRange({ cidr_value: '' });
        setIsEditing(false);
        setEditIndex(null);
        setFormErrors({});
        setApiError(null);
        // Cancel user edit
        setIsEditingUser(false);
        setEditUserIndex(null);
        setNewUser({ email: '' });
        setIsAdd(!isAdd);
    };

    const handleInputChange = (e) => {
        setNewIpRange({ ...newIpRange, [e.target.name]: e.target.value });
    };

    const validate = () => {
        const errors = {};
        const cidrRegex = /^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))$/;

        if (!newIpRange.cidr_value.trim()) {
          errors.cidr_value = 'CIDR Range is required';
        } else if (!cidrRegex.test(newIpRange.cidr_value.trim())) {
          errors.cidr_value = 'Invalid CIDR format (e.g., 192.168.1.0/24)';
        }
        return errors;
    };

    const handleSave = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
          setFormErrors(validationErrors);
          return;
        }

        let payload;
        if (isEditing) {
            payload = { id: newIpRange.id, cidr_value: newIpRange.cidr_value.trim() };
        } else {
            payload = { cidr_value: newIpRange.cidr_value.trim() };
        }

        try {
            setButtonDisabled(true);
            setPopupOpen(true);
            await axiosJWT.post(`${baseUrl}/uptivity-ip-list`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setIsAdd(false);
            setIsEditing(false);
            setEditIndex(null);
            setNewIpRange({ cidr_value: '' });
            getIpRangeList(page);
            setApiError(null);
        } catch (error) {
            console.error("Error saving Uptivity IP Range:", error);
            if (error.response?.status === 403) {
                setApiError("Access denied. This action requires SuperAdmin privileges from an MFA-exempt IP.");
            } else {
                setApiError(error.response?.data?.msg || error.response?.data?.message || "Failed to save Uptivity IP Range. Please try again.");
            }
        } finally {
            setButtonDisabled(false);
            setPopupOpen(false);
        }
        setFormErrors({});
    };

    const handleEdit = (index) => {
        if (editIndex === index) {
            // Toggle off — cancel edit
            setIsEditing(false);
            setEditIndex(null);
            setNewIpRange({ cidr_value: '' });
            setFormErrors({});
            return;
        }
        // Cancel any user edit in progress
        setIsEditingUser(false);
        setEditUserIndex(null);
        setNewUser({ email: '' });
        setUserFormErrors({});

        const ipRange = ipRanges[index];
        setNewIpRange({...ipRange});
        setIsEditing(true);
        setEditIndex(index);
        setIsAdd(false);
        setFormErrors({});
        setApiError(null);
    };

    // ── Authorized Users handlers ──────────────────────────────────────────

    const getUserList = async (pageNumber) => {
        setPopupOpen(true);
        try {
            const response = await axiosJWT.get(`${baseUrl}/uptivity-access-users?page=${pageNumber}&limit=20`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setUsers(response.data.data);
            setTotalUserItem(response.data.totalItem);
        } catch (err) {
            console.error("Error fetching Uptivity access users:", err);
        } finally {
            setPopupOpen(false);
        }
    };

    const handleAddUser = () => {
        setNewUser({ email: '' });
        setIsEditingUser(false);
        setEditUserIndex(null);
        setUserFormErrors({});
        // Cancel IP edit
        setIsEditing(false);
        setEditIndex(null);
        setNewIpRange({ cidr_value: '' });
        setIsAddUser(!isAddUser);
    };

    const handleUserInputChange = (e) => {
        setNewUser({ ...newUser, [e.target.name]: e.target.value });
    };

    const validateUser = () => {
        const errors = {};
        const emailVal = newUser.email.trim().toLowerCase();
        if (!emailVal) {
            errors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
            errors.email = 'Invalid email format';
        } else if (!emailVal.endsWith('@broadbanddynamics.com') && !emailVal.endsWith('@ucbinc.com')) {
            errors.email = 'Only @broadbanddynamics.com or @ucbinc.com email addresses are allowed';
        }
        return errors;
    };

    const handleSaveUser = async () => {
        setUserFormErrors({});
        const validationErrors = validateUser();
        if (Object.keys(validationErrors).length > 0) {
            setUserFormErrors(validationErrors);
            return;
        }

        const payload = isEditingUser
            ? { id: newUser.id, email: newUser.email.trim() }
            : { email: newUser.email.trim() };

        try {
            setUserButtonDisabled(true);
            setPopupOpen(true);
            await axiosJWT.post(`${baseUrl}/uptivity-access-users`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setIsAddUser(false);
            setIsEditingUser(false);
            setEditUserIndex(null);
            setNewUser({ email: '' });
            getUserList(userPage);
        } catch (error) {
            console.error("Error saving Uptivity access user:", error);
            setUserFormErrors({ email: error.response?.data?.msg || "Failed to save user. Please try again." });
        } finally {
            setUserButtonDisabled(false);
            setPopupOpen(false);
        }
    };

    const handleEditUser = (index) => {
        if (editUserIndex === index) {
            // Toggle off — cancel edit
            setIsEditingUser(false);
            setEditUserIndex(null);
            setNewUser({ email: '' });
            setUserFormErrors({});
            return;
        }
        // Cancel any IP edit in progress
        setIsEditing(false);
        setEditIndex(null);
        setNewIpRange({ cidr_value: '' });
        setFormErrors({});

        const user = users[index];
        setNewUser({ ...user });
        setIsEditingUser(true);
        setEditUserIndex(index);
        setIsAddUser(false);
        setUserFormErrors({});
    };

    const disableUser = async (id) => {
        const shouldDelete = window.confirm("Are you sure you want to remove this user's Uptivity access?");
        if (shouldDelete) {
            try {
                setPopupOpen(true);
                await axiosJWT.delete(`${baseUrl}/uptivity-access-users/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                getUserList(userPage);
            } catch (error) {
                console.error("Error removing Uptivity access user:", error);
            } finally {
                setPopupOpen(false);
            }
        }
    };

    const disableIpRange = async (id) => {
        const shouldDelete = window.confirm("Are you sure you want to disable this Uptivity IP Range? This will prevent access from this IP range.");
        if (shouldDelete) {
            try {
                setPopupOpen(true);
                await axiosJWT.delete(`${baseUrl}/uptivity-ip-list/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                getIpRangeList(page);
                setApiError(null);
            } catch (error) {
                console.error("Error disabling Uptivity IP Range:", error);
                if (error.response?.status === 403) {
                    setApiError("Access denied. This action requires SuperAdmin privileges from an MFA-exempt IP.");
                } else {
                    setApiError(error.response?.data?.msg || error.response?.data?.message || "Failed to disable Uptivity IP Range.");
                }
            } finally {
                setPopupOpen(false);
            }
        }
    }

    return (
        <div className="panelbox">
           <Navbar token={token} access={access}/>
            <div className="right-panel">
            <Header name={userName} />
            {popupOpen && <Loader />}
            <div className="content-page admin-attendance-page">
                <div className="row">
                    {apiError && <div className="col-12"><p className="error error-message" style={{color: 'red'}}>{apiError}</p></div>}
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="left-title">
                            <h1>Uptivity IP Whitelist</h1>
                            <p style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
                                Manage IP addresses authorized to access UCB Uptivity recordings.
                                Changes will trigger email notifications to security@broadbanddynamics.com
                            </p>
                        </div>
                    </div>
                    <div className="col-6 inventory-btn">
                        <div className="addnew-button">
                            <Link to="/settings"><span>&larr;</span> Back</Link>
                            <a className="newrow" onClick={handleAddIpRange} style={{ cursor: 'pointer' }}> Add IP Range</a>
                        </div>
                    </div>
                </div>
                <div className="fullrow">
                    <div className="row">
                        <div className="col-12">
                        { isAdd &&
                            <div className="common-white-shadow-background setting-section">
                                <div className="row">
                                    <div className="col-sm-6" >
                                        <input
                                            type="text"
                                            name="cidr_value"
                                            placeholder="CIDR Range (e.g., 192.168.1.0/24)"
                                            value={newIpRange.cidr_value}
                                            onChange={handleInputChange}
                                        />
                                        {formErrors.cidr_value && <div className="error error-message">{formErrors.cidr_value}</div>}
                                    </div>
                                    <div className="col-sm-3 boxinput company-search" >
                                        <a href="#" className={buttonDisabled ? 'disabled-link search-btn clear-btn' : 'search-btn clear-btn'} onClick={handleSave} >Save</a>
                                    </div>
                                </div>
                            </div>}

                            <div className="fullwidth-table track-table-body">
                                <table style={{width: '100%', tableLayout: 'fixed'}}>
                                    <thead style={{background: '#D9D9D9'}}>
                                    <tr>
                                        <th style={{width: '25%', textAlign: 'left', paddingLeft: '12px', color: '#1A2E5C'}}>CIDR Range</th>
                                        <th style={{width: '25%', textAlign: 'center', color: '#1A2E5C'}}>Created (UTC)</th>
                                        <th style={{width: '25%', textAlign: 'center', color: '#1A2E5C'}}>Last Updated (UTC)</th>
                                        <th style={{width: '25%', textAlign: 'center', color: '#1A2E5C'}}>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {ipRanges.map((item, index) => (
                                        <tr key={item.id}>
                                            <td style={{textAlign: 'left', paddingLeft: '12px'}}>
                                                {editIndex === index ?
                                                    <>
                                                    <input
                                                        type="text"
                                                        name="cidr_value"
                                                        placeholder="CIDR Range"
                                                        value={newIpRange.cidr_value}
                                                        onChange={handleInputChange}
                                                    />
                                                    {formErrors.cidr_value && <div className="error error-message">{formErrors.cidr_value}</div>}</> :
                                                    item.cidr_value
                                                }
                                            </td>
                                            <td style={{overflow: 'hidden', whiteSpace: 'nowrap', textAlign: 'center'}}>{formatDateTimeToPST(item.created_at, '', role)}</td>
                                            <td style={{overflow: 'hidden', whiteSpace: 'nowrap', textAlign: 'center'}}>{formatDateTimeToPST(item.updated_at, '', role)}</td>
                                            <td style={{textAlign: 'center'}}>
                                            {editIndex === index && <a href="#" className={buttonDisabled ? 'disabled-link' : ''}  onClick={handleSave} ><img src={`${process.env.PUBLIC_URL}/images/success.png`} alt="Save" title="Save Changes" /></a>}
                                                {item.status === 1 && editIndex !== index && <a onClick={() => handleEdit(index)}><img src={`${process.env.PUBLIC_URL}/images/bx-edit.png`} alt="Edit" title="Edit IP Range" /></a>}
                                                <a onClick={() => disableIpRange(item.id)}><img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`} alt="Disable" title="Disable IP Range" /></a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                {totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Authorized Users Section ─────────────────────────────── */}
                <div className="fullrow" style={{marginTop: '40px'}}>
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Authorized Users</h1>
                                <p style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
                                    Manage users authorized to access UCB Uptivity recordings.
                                    Users must also be accessing from a whitelisted IP range.
                                </p>
                            </div>
                        </div>
                        <div className="col-6 inventory-btn">
                            <div className="addnew-button">
                                <a className="newrow" onClick={handleAddUser} style={{ cursor: 'pointer' }}> Add User</a>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {isAddUser &&
                                <div className="common-white-shadow-background setting-section">
                                    <div className="row">
                                        <div className="col-sm-9">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="User Email (e.g., user@company.com)"
                                                value={newUser.email}
                                                onChange={handleUserInputChange}
                                            />
                                            {userFormErrors.email && <div className="error error-message">{userFormErrors.email}</div>}
                                        </div>
                                        <div className="col-sm-3 boxinput company-search">
                                            <a href="#" className={userButtonDisabled ? 'disabled-link search-btn clear-btn' : 'search-btn clear-btn'} onClick={handleSaveUser}>Save</a>
                                        </div>
                                    </div>
                                </div>}

                            <div className="fullwidth-table track-table-body">
                                <table style={{width: '100%', tableLayout: 'fixed'}}>
                                    <thead style={{background: '#D9D9D9'}}>
                                        <tr>
                                            <th style={{width: '25%', textAlign: 'left', paddingLeft: '12px', color: '#1A2E5C'}}>Email</th>
                                            <th style={{width: '25%', textAlign: 'center', color: '#1A2E5C'}}>Created (UTC)</th>
                                            <th style={{width: '25%', textAlign: 'center', color: '#1A2E5C'}}>Last Updated (UTC)</th>
                                            <th style={{width: '25%', textAlign: 'center', color: '#1A2E5C'}}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.map((item, index) => (
                                            <tr key={item.id}>
                                                <td style={{wordBreak: 'break-all', textAlign: 'left', paddingLeft: '12px'}}>
                                                    {editUserIndex === index ?
                                                        <>
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                placeholder="User Email"
                                                                value={newUser.email}
                                                                onChange={handleUserInputChange}
                                                                style={{width: '100%'}}
                                                            />
                                                            {userFormErrors.email && <div className="error error-message">{userFormErrors.email}</div>}
                                                        </> :
                                                        item.email
                                                    }
                                                </td>
                                                <td style={{overflow: 'hidden', whiteSpace: 'nowrap', textAlign: 'center'}}>{formatDateTimeToPST(item.created_at, '', role)}</td>
                                                <td style={{overflow: 'hidden', whiteSpace: 'nowrap', textAlign: 'center'}}>{formatDateTimeToPST(item.updated_at, '', role)}</td>
                                                <td style={{textAlign: 'center'}}>
                                                    {editUserIndex === index && <a href="#" className={userButtonDisabled ? 'disabled-link' : ''} onClick={handleSaveUser}><img src={`${process.env.PUBLIC_URL}/images/success.png`} alt="Save" title="Save Changes" /></a>}
                                                    {item.status === 1 && editUserIndex !== index && <a onClick={() => handleEditUser(index)}><img src={`${process.env.PUBLIC_URL}/images/bx-edit.png`} alt="Edit" title="Edit User" /></a>}
                                                    <a onClick={() => disableUser(item.id)}><img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`} alt="Remove" title="Remove User Access" /></a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {totalUserItem > 20 && (<Pagination
                                    activePage={userPage}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalUserItem}
                                    pageRangeDisplayed={5}
                                    onChange={(p) => setUserPage(p)}
                                />)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default UptivityIPListSettings;
